import { render, staticRenderFns } from "./upcgenerator-old.vue?vue&type=template&id=2d875030&"
import script from "./upcgenerator-old.vue?vue&type=script&lang=js&"
export * from "./upcgenerator-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports